import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { navigateTo } from 'gatsby-link';
import { Button } from 'reactstrap';

import './PostCard.scss';

const PostCard = props => {
  const blogPost = props.blogPost.node;
  const transformedPost =
    blogPost.childContentfulBlogPostPostTextNode.childMarkdownRemark;
  const excerpt = transformedPost.excerpt;
  const { title, sizes } = blogPost.heroPhoto;

  const link = `/${blogPost.node_locale}/blog/${blogPost.slug}`;

  return (
    <div className="post-card">
      <div onClick={() => navigateTo(link)}>
        <Img alt={title} sizes={sizes} />
      </div>
      <div className="text-muted">{blogPost.date}</div>
      <div className="text-muted">
        {transformedPost.timeToRead} {props.timeToRead}
      </div>
      <h3>{blogPost.title}</h3>
      <p>{excerpt}</p>
      <Button onClick={() => navigateTo(link)} color="secondary">
        {props.lireArticle}
      </Button>
    </div>
  );
};

PostCard.propTypes = {
  blogPost: PropTypes.object.isRequired,
  timeToRead: PropTypes.string.isRequired,
  lireArticle: PropTypes.string.isRequired,
};

export default PostCard;



// WEBPACK FOOTER //
// ./src/components/Main/home/PostCard.js